import CartGoodsBlock from './CartGoodsBlock'

export default CartGoodsBlock
